<div *ngIf="loading"
     class="loading-overlay">
    <i class="fa fa-2x fa-spinner fa-spin text-secondary"></i>
    <h3 class="mt-3 ml-1 text-secondary">Cargando...</h3>
</div>

<div class="row ">

    <div class="col-12">
        <div class="card border rounded animated fadeIn fast">
            <div class="card-body animated fadeIn fast">


                <!-- cabecera -->
                <div class="row mb-2">

                    <div class="col-3">
                        <div class="form-group border border-dark rounded">
                            <input class="form-control"
                                   type="text"
                                   autofocus
                                   placeholder="Buscar cualquier dato..."
                                   (keyup)="buscarTodo($event)" />
                        </div>
                    </div>

                    <div class="col-3">
                        <div class=" input-group border border-dark rounded"
                             title="Almacén">
                            <div class="input-group-addon"><i class="fa-solid fa-warehouse"></i></div>
                            <select class="form-control "
                                    [(ngModel)]="almSeleccionado"
                                    (ngModelChange)="onAlmacenSelect($event)">
                                <option value=0>Todos los almacenes</option>
                                <option *ngFor="let alm of almacenesList"
                                        [value]=alm.id>
                                    {{alm.nombre}}
                                </option>
                            </select>
                        </div>
                    </div>

                    <div class="col-3">
                        <div class=" input-group border border-dark rounded"
                             title="Pasillo">
                            <div class="input-group-addon"><i class="fa-solid fa-road"></i></div>
                            <select class="form-control "
                                    [(ngModel)]="pasilloSeleccionado"
                                    (ngModelChange)="onPasilloSelect($event)">
                                <option value=0>Todos los pasillos</option>
                                <option *ngFor="let pasillo of pasillosList"
                                        [value]=pasillo>
                                    {{pasillo}}
                                </option>
                            </select>
                        </div>
                    </div>



                    <div class="col-3">
                        <form>

                            <div class="row float-right">
                                <div class="col-sm-5">
                                    <div class="form-group rounded">
                                        <select class="form-control"
                                                name="rowsLimitStr"
                                                [(ngModel)]="rowsLimitStr"
                                                (change)="rowsLimitChange()">
                                            <option [value]="10">10</option>
                                            <option [value]="50">50</option>
                                            <option [value]="100">100</option>
                                            <option [value]="999999">Todo</option>
                                        </select>
                                    </div>
                                </div>
                                <div class="col-sm-7">
                                    <div class="form-group float-right">
                                        <div class="btn-group">
                                            <button type="button"
                                                    [routerLink]="'/panel/ubicacion/new'"
                                                    class="btn btn-outline-info btn-circle"
                                                    title="Nuevo">
                                                <i class="fa-solid fa-plus"></i>
                                            </button>
                                            <button type="button"
                                                    [routerLink]="'/panel/ubicaciones_labels'"
                                                    class="btn btn-outline-info btn-circle"
                                                    title="Imprimir Eqtiquetas">
                                                <i class="fa-solid fa-tag"></i>
                                            </button>
                                            <button type="button"
                                                    (click)="cargaLista()"
                                                    class="btn btn-outline-info btn-circle"
                                                    title="Recargar datos">
                                                <i class="fa-solid fa-sync"></i>
                                            </button>
                                            <button type="button"
                                                    (click)="exportToExcel()"
                                                    class="btn btn-outline-info btn-circle"
                                                    title="Descargar Excel">
                                                <i class="fa-solid fa-download"></i>
                                            </button>
                                        </div>
                                    </div>
                                </div>
                            </div>


                        </form>
                    </div>

                </div>



                <div class="rounded border">

                    <!-- datatable -->
                    <ngx-datatable class='bootstrap'
                                   [style.width]="'100%'"
                                   [columnMode]="'force'"
                                   [loadingIndicator]="loading"
                                   [headerHeight]="70"
                                   [footerHeight]="50"
                                   [rowHeight]="50"
                                   [limit]="rowsLimit"
                                   [rows]='rows'
                                   [messages]="messages">


                        <!-- id -->
                        <ngx-datatable-column name="id"
                                              [flexGrow]="0.5"
                                              [minWidth]="60"
                                              [maxWidth]="80"
                                              [resizeable]="false">
                            <ng-template ngx-datatable-cell-template
                                         let-value="value">
                                {{value}}
                            </ng-template>
                        </ngx-datatable-column>


                        <!-- Código -->
                        <ngx-datatable-column name="Código"
                                              prop="codigo"
                                              [width]="160"
                                              [maxWidth]="160"
                                              [resizeable]="false">
                            <ng-template let-value="value"
                                         let-row="row"
                                         ngx-datatable-cell-template>
                                <div title={{funcLib.CodUbiDecript(value)}}
                                     class="monospace"
                                     [innerHTML]="funcLib.resaltarTexto(funcLib.formatUbicacion(value), textoDestacado | mask: '00.00.00.00.00.00')"></div>
                            </ng-template>

                        </ngx-datatable-column>

                        <!-- Ocupado -->
                        <ngx-datatable-column name="Ocupado"
                                              prop="swOcupado"
                                              [width]="70"
                                              [maxWidth]="90">
                            <ng-template let-value="value"
                                         ngx-datatable-cell-template>
                                <div title="Ocupada"
                                     [innerHTML]="value | iconCheck"></div>
                            </ng-template>
                        </ngx-datatable-column>

                        <!-- Peso -->
                        <ngx-datatable-column name="Peso asignado"
                                              prop="peso"
                                              [width]="130"
                                              [maxWidth]="150"
                                              [cellClass]="'text-right'">
                            <ng-template ngx-datatable-header-template
                                         let-column="column">
                                <span title="Peso para la asignación de Stock, Ubicaciones con mayor peso primero">
                                    {{column.name}} <i class="fa-solid fa-circle-info ml-1"></i>
                                </span>
                            </ng-template>
                            <ng-template let-value="value"
                                         ngx-datatable-cell-template>
                                <div class="italic small"
                                     [innerHTML]="funcLib.resaltarTexto(value, textoDestacado)"></div>
                            </ng-template>
                        </ngx-datatable-column>

                        <!-- orden_recogida -->
                        <ngx-datatable-column name="Orden Recogida"
                                              prop="orden_recogida"
                                              [width]="130"
                                              [maxWidth]="150"
                                              [cellClass]="'text-right'">
                            <ng-template ngx-datatable-header-template
                                         let-column="column">
                                <span title="Orden de paso, cuanto más bajo, antes se asignará el paso por esta ubicación en recogidas">
                                    {{column.name}} <i class="fa-solid fa-circle-info ml-1"></i>
                                </span>
                            </ng-template>
                            <ng-template let-value="value"
                                         ngx-datatable-cell-template>
                                <div class="italic small"
                                     [innerHTML]="funcLib.resaltarTexto(value, textoDestacado)"></div>
                            </ng-template>
                        </ngx-datatable-column>

                        <!-- orden_de_recorrido -->
                        <ngx-datatable-column name="Orden Recorrido"
                                              prop="orden_de_recorrido"
                                              [width]="130"
                                              [maxWidth]="150"
                                              [cellClass]="'text-right'">
                            <ng-template ngx-datatable-header-template
                                         let-column="column">
                                <span title="Orden de recorrido, cuanto más bajo, antes se ordenará (Una vez tenemos la lista de RECOGIDAS asignada para llenar los UIC’s por el almacén) ">
                                    {{column.name}} <i class="fa-solid fa-circle-info ml-1"></i>
                                </span>
                            </ng-template>
                            <ng-template let-value="value"
                                         ngx-datatable-cell-template>
                                <div class="italic small"
                                     [innerHTML]="funcLib.resaltarTexto(value, textoDestacado)"></div>
                            </ng-template>
                        </ngx-datatable-column>

                        <!-- Comentario -->
                        <ngx-datatable-column name="Comentario"
                                              prop="comentario"
                                              [flexGrow]="5">
                            <ng-template let-value="value"
                                         ngx-datatable-cell-template>
                                <div [innerHTML]="funcLib.resaltarTexto(value, textoDestacado)"></div>
                            </ng-template>
                        </ngx-datatable-column>

                        <!-- Tipo -->
                        <ngx-datatable-column name="Tipo"
                                              [flexGrow]="2">
                            <ng-template let-row="row"
                                         ngx-datatable-cell-template>
                                <div *ngIf="row.tipo"
                                     [innerHTML]="funcLib.resaltarTexto(row.tipo.nombre, textoDestacado)"></div>
                            </ng-template>
                        </ngx-datatable-column>

                        <!-- Dimensiones -->
                        <ngx-datatable-column name="Dim. máx. cm"
                                              title="Largo x Ancho x Alto"
                                              [flexGrow]="2">
                            <ng-template let-row="row"
                                         ngx-datatable-cell-template>
                                <div *ngIf="row.tipo"
                                     [innerHTML]="funcLib.resaltarTexto(row.tipo.largo +'x'+row.tipo.ancho+'x'+ row.tipo.alto, textoDestacado)"></div>
                            </ng-template>
                        </ngx-datatable-column>




                        <!-- Acciones -->
                        <ngx-datatable-column [flexGrow]="10"
                                              [sortable]="false"
                                              [draggable]="false"
                                              [resizeable]="false">

                            <ng-template let-row="row"
                                         let-value="value"
                                         ngx-datatable-cell-template>

                                <div ngbDropdown
                                     class="d-inline-block "
                                     container="body">
                                    <button class="btn btn-sm btn-outline-secondary dropdown-toggle"
                                            data-toggle="dropdown"
                                            type="button"
                                            style="border-width: 1px;">
                                        <i class="fa-solid fa-ellipsis-vertical"></i>
                                    </button>
                                    <div class="dropdown-menu dropdown-menu-left">

                                        <a [routerLink]="['/panel/ubicacion',row.id]"
                                           class="link mr-2 dropdown-item"
                                           placement="top"
                                           title="Editar Ubicación">
                                            <i class="fa-solid fa-pen-to-square"></i> Editar Ubicación
                                        </a>

                                        <hr style="margin: 0px;">

                                        <a (click)="  null"
                                           class="link mr-2 dropdown-item text-danger"
                                           title="Borrar"
                                           [class.disabled]="true"
                                           [attr.aria-disabled]="true">
                                            <i class="fa-regular fa-trash-can fa"></i> Borrar
                                        </a>


                                    </div>
                                </div>

                            </ng-template>
                        </ngx-datatable-column>






                    </ngx-datatable>

                </div>


            </div>



        </div>
    </div>



</div>





<!-- Estadísticas por Pasillo -->
<div *ngIf="almSeleccionado !== '0'"
     class="row">

    <div class="col-12">
        <div class="card border rounded animated fadeIn fast">

            <!-- Cabecera -->
            <div class="card-header badge-secondary text-white">
                <h6 class="mb-0">
                    <a class="card-link text-white"
                       href="javascript:void(0)"
                       (click)="collapseEstadisticas = !collapseEstadisticas">
                        <i class="fa fa-chart-bar"></i> Estadísticas de ocupación por Pasillos
                        <i class="fa ml-2"
                           [ngClass]="{
                        'fa-chevron-down': !collapseEstadisticas,
                        'fa-chevron-up': collapseEstadisticas
                        }"></i>
                    </a>
                </h6>
            </div>

            <!-- Cuerpo -->
            <div class="card-body animated fadeIn fast"
                 id="collapseEstadisticas"
                 class="collapse"
                 [ngClass]="{ 'show': collapseEstadisticas }"
                 aria-labelledby="headingEstadisticas">

                <div class="card-body">
                    <div class="row">
                        <div class="col-md-2"
                             *ngFor="let item of obtenerEstadisticasPorPasillo() | keyvalue">
                            <div class="mb-2"
                                 [title]="item.value.porcentaje < 40 ? 'Ocupación Baja' : item.value.porcentaje >= 40 && item.value.porcentaje <= 70 ? 'Ocupación Media' : 'Ocupación Alta'">
                                <strong class="monospace">
                                    Pasillo {{ item.key }}:
                                </strong>
                                <span class="badge ml-1"
                                      [ngClass]="{
                                        'badge-success': item.value.porcentaje < 40,
                                        'badge-warning': item.value.porcentaje >= 40 && item.value.porcentaje <= 70,
                                        'badge-danger': item.value.porcentaje > 70
                                    }"
                                      style="font-family: 'Courier New', Courier, monospace;">
                                    {{ item.value.ocupadas }}/{{ item.value.total }} ({{ item.value.porcentaje }}%)
                                </span>
                            </div>
                        </div>
                    </div>
                </div>

            </div>

        </div>
    </div>

</div>